import useAppVersion from "../hooks/useAppVersion";

/**
 * Mounted once at app root so version polling survives route changes.
 * The branded notice is shown via react-toastify (AppUpdateNotice).
 */
export default function AppVersionChecker() {
  useAppVersion();
  return null;
}
